// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

Vue.prototype.axios = axios
import app from './components/common/js/App.js'
import Qs from 'qs'

import Vuex from 'vuex'
import VueWechatTitle from 'vue-wechat-title'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
// swiper 4.x
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueWechatTitle)
Vue.use(Vuex)
Vue.use(iView)
Vue.use(VueAwesomeSwiper)

/*axios全局配置*/
console.log("当前环境：" + process.env.NODE_ENV)	//打印结果为production 或 development
if (process.env.NODE_ENV == "development") {
  axios.defaults.baseURL = app.baseURL = app.baseURL_dev;
} else {
  axios.defaults.baseURL = app.baseURL = app.baseURL_pro;
}
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Accept'] = 'application/json';
axios.defaults.transformRequest = [function (data) {
  data = Qs.stringify(data)
  return data;
}];
axios.defaults.transformResponse = [function (data) {
  data = JSON.parse(data)
  // 405登录失效，跳转
  if (data.status == 405) {
    localStorage.clear();
//  	var cf = confirm(data.msg);
//  	if(cf==true){
//  		window.location.href = "/";
//  	}else{
//  		setTimeout(function(){
//  			window.location.href = "/";
//  		},3000);
//  	}
  }
  return data;
}];

Vue.config.productionTip = false
const wxTokne = {
  AppID:"",
  AppSecret:'',
  redirect_uri:''
}
const mystore = new Vuex.Store({
  root: true,
  state: {
    api_token: "",
    date: "",
    noon:"1",
    wx_Config: {}
  },
  mutations: {
    // 临时用于首页手机号登录
    updateToken: function (state) {
      state.api_token = localStorage.getItem("api_token");
    },
    updateDate : function (state,date) {
      state.date = date
    },
    updateNoon : function (state,val) {
      state.noon = val
    }
  },
  getters: {},
  actions: {}
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: mystore,
  components: {App},
  template: '<App/>'
})

/* 路由跳转前，执行 */
// router.beforeEach((to, from, next) => {
//   next();
// })

/* 路由进入前，执行 */
// router.beforeResolve((to, from, next) => {
//   if (to.meta.needLogin) {
//     if (localStorage.getItem("api_token")) {
//       mystore.state.api_token = localStorage.getItem("api_token");
//       axios({
//         method: 'get',
//         url: '/api/users/info',
//         params: {
//           p: "wx",
//           api_token: mystore.state.api_token
//         }
//       })
//         .then(function (rlt) {
//           if (rlt.data.status == 1) {
//             next();
//           } else {
//             window.location.href = "http://cxstm.museum-edu.cn/wxToken/wxLoginRedirect.php?vue_url=" + to.fullPath;
//           }
//         })
//         .catch(function (error) {
//           console.log(error);
//         });

//     } else if (app.getUrlKey("token")) {
//       localStorage.setItem("api_token", app.getUrlKey("token"));
//       mystore.state.api_token = localStorage.getItem("api_token");
//       next();
//     } else {
//       window.location.href = "http://cxstm.museum-edu.cn/wxToken/wxLoginRedirect.php?vue_url=" + to.fullPath;
//     }
//   } else {
//     next();
//   }
// })
/* 路由跳转后，执行 */
router.afterEach((to, from) => {
  // 返回顶部
  window.scrollTo(0, 0);

})


// WEBPACK FOOTER //
// ./src/main.js